export default __webpack_public_path__ + "static/media/upgrade-weapons.24e266a1.png";